<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus  -->
<div
  #modalBackdrop
  class="modal__backdrop"
  (click)="close()"></div>

<div class="modal__wrapper">
  <div
    #modalContainer
    class="modal__container"
    [style]="styles()">
    <div class="modal__header">
      <div class="modal__title">
        <ng-content select="[modal-title]" />
      </div>

      @let hasControls = showReduceButton() || showCloseButton();
      @if (hasControls) {
        <div class="modal__controls">
          @if (showCloseButton()) {
            <evc-button
              size="small"
              icon="close"
              frame="ghost"
              data-testid="modal-close"
              (click)="close()"></evc-button>
          }
        </div>
      }
    </div>

    <div
      class="modal__content"
      [attr.data-type]="type()">
      <ng-content select="[modal-content]" />
    </div>

    <div class="modal__actions">
      <ng-content select="[modal-actions]" />
    </div>
  </div>
</div>
